import type { ReactNode } from 'react';

import type { Session } from '@/entities/session';
import { BLANK_NESSO_NOTE_CONTENT, type UpdateSessionNoteContentFn } from '@/entities/session-note';

import { NessoSessionNoteContent } from './nesso-session-note/nesso-session-note-content';

type Props = {
    session: Session;
    header: ReactNode;
    disclaimer: ReactNode;
    updateContent: UpdateSessionNoteContentFn;
};

export function NessoSessionNote({ session, header, disclaimer, updateContent }: Props) {
    const note = session.currentNote?.type === 'NESSO' ? session.currentNote : null;
    const nessoContent = note?.content ?? BLANK_NESSO_NOTE_CONTENT;

    return (
        <div className="max-w-[38.875rem] space-y-8">
            {header}
            <NessoSessionNoteContent
                content={nessoContent}
                updateContent={updateContent}
                disclaimer={disclaimer}
            />
        </div>
    );
}
